import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../../footer'
import { InstructorHeader } from '../../instructor/header'
import InstructorSidebar from '../sidebar'
import { getIdData } from '../../../lib/instructorinfo'
import { useNavigate, useParams } from 'react-router-dom'
import InstructorScheduleDays from "../instructorGrid/scheduledays"

export default function AdminIntructorDetail() {
  const [intructorInfo, setIntructorInfo] = useState()
  const navigate = useNavigate()
  let { slug } = useParams()

  async function GetData() {
    const info = await getIdData(slug)
    setIntructorInfo(info)
    console.log('info', info)
  }

  useEffect(() => {
    GetData()
  }, [])
  return (
    <div className='col-12'>
      <div className='tak-instruct-group'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='settings-widget'>
              <div className='settings-inner-blk p-0'>
                <div className='sell-course-head comman-space'>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <button
              onClick={() => navigate(-1)}
              className="btn btn-black btn-sm"
            >
              {"<< Back"}
            </button>
            <h3>Instructor Details</h3>
                  <p></p>
                </div>
                </div>
              </div>
            </div>
            <div className='settings-widget'>
              <div className='settings-inner-blk p-0'>
                <div className='checkout-form personal-address add-course-info'>
                  <form action='#'>
                    <div className='row'>
                      <div className='col-lg-6'>
                        <div className='form-group'>
                          <label className='form-control-label'>
                            First Name
                          </label>
                          <p>{intructorInfo ? intructorInfo[0].name : ''}</p>
                        </div>
                      </div>
                      <div className='col-lg-6'>
                        <div className='form-group'>
                          <label className='form-control-label'>
                            Last Name
                          </label>
                          <p>{intructorInfo ? intructorInfo[0].surname : ''}</p>
                        </div>
                      </div>
                      <div className='col-lg-6'>
                        <div className='form-group'>
                          <label className='form-control-label'>Phone</label>
                          <p>{intructorInfo ? intructorInfo[0].phone : ''}</p>
                        </div>
                      </div>
                      <div className='col-lg-6'>
                        <div className='form-group'>
                          <label className='form-control-label'>Email</label>
                          <p>{intructorInfo ? intructorInfo[0].email : ''}</p>
                        </div>
                      </div>
                      <div className='col-lg-6'>
                        <div className='form-group'>
                          <label className='form-control-label'></label>
                          <p></p>
                        </div>
                      </div>
                      <div className='col-lg-6'>
                        <div className='form-group'>
                          <label className='form-label'>-</label>
                          <p>-</p>
                        </div>
                      </div>
                      <div className='update-profile'>
                        <button
                          type='button'
                          className='btn btn-primary'
                          onClick={() =>
                            navigate(
                              `/admin/admin-instructorstep2/${slug}/Update`
                            )
                          }
                        >
                          Update Profile
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
              <InstructorScheduleDays slug={slug}/>
          </div>
        </div>
      </div>
    </div>
  )
}
